// Some dataset titles come straight from ArcGIS service names, which use
// '_' for spaces (e.g. Caltrans_UC_Davis_Wildfire_Assessment_2020). Display
// only (plus catalog sorting, see compareTitles) - search and CKAN data keep
// the original title.
const formatTitle = (title) => {
  if (typeof title !== 'string') return title;
  return title.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
};
// Sorts by the title as displayed, so e.g. "_Fire_Density_SCIRP_SoCal" files
// under F rather than ahead of A.
const compareTitles = (a, b) => formatTitle(a).localeCompare(formatTitle(b));
export { formatTitle, compareTitles };
